import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number, currency = "CZK"): string {
  return new Intl.NumberFormat("cs-CZ", { style: "currency", currency }).format(amount);
}

export function formatHours(hours: number): string {
  return `${hours.toFixed(2)} h`;
}

export function formatDate(
  date: Date | string,
  timeZone?: string,
  opts?: { withTime?: boolean },
): string {
  const dateTimeOpts: Intl.DateTimeFormatOptions = {
    ...(timeZone ? { timeZone } : {}),
    ...(opts?.withTime
      ? {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        }
      : {}),
  };
  return new Intl.DateTimeFormat("cs-CZ", dateTimeOpts).format(new Date(date));
}

export function formatRelative(date: Date | string, timeZone?: string): string {
  const d = new Date(date);
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return "just now";
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHour < 24) return `${diffHour}h ago`;
  if (diffDay === 1) return "Yesterday";
  if (diffDay < 7) return `${diffDay} days ago`;

  return new Intl.DateTimeFormat(
    "en-GB",
    timeZone ? { day: "numeric", month: "short", timeZone } : { day: "numeric", month: "short" },
  ).format(d);
}
